import cn from 'classnames';
import { MealPlanAnalyticsLocation } from 'common/events/ClientEvents';
import { FavoriteButton } from 'src/pages/consumer/follow-shef/FavoriteButton';
import { useFollowButton } from 'src/pages/consumer/follow-shef/hooks';
import { MealPlanFoodItem } from 'src/pages/consumer/meal-plans/checkout/types';
import { useShareDish } from 'src/shared/hooks/useShareDish';
import { Icon, IconColor } from 'web-common/src/shared/design-system/components/Icon';

interface InteractionButtonsProps {
  foodItem: MealPlanFoodItem;
  analyticsLocation?: MealPlanAnalyticsLocation;
}

export const InteractionButtons: React.FC<InteractionButtonsProps> = ({
  foodItem,
  analyticsLocation = 'dish-modal',
}) => {
  const { publicName, id: shefId } = foodItem.shef;
  const buttonClassName = 'flex flex-col items-center text-caption-400 text-eggplant-500 w-[96px]';

  /**
   * ========================================================
   * Share dish
   * ========================================================
   */
  const { share, copied } = useShareDish(foodItem);

  const renderShareDishButton = (
    <button onClick={share} className={buttonClassName}>
      <Icon name='share' color={IconColor.RASPBERRY} size={24} />
      <span className='mt-4'>{copied ? 'Copied!' : 'Share dish'}</span>
    </button>
  );

  /**
   * ========================================================
   * Favorite shef
   * ========================================================
   */
  const { buttonProps: followButtonProps } = useFollowButton({
    name: publicName,
    shefId,
    location: analyticsLocation,
  });

  const renderFavoriteButton = (
    <div onClick={followButtonProps.onClick} className={cn(buttonClassName, 'mr-20')}>
      <FavoriteButton shefName={publicName} shefId={shefId} analyticsLocation={analyticsLocation} />
      <span>{followButtonProps.isFollowing ? 'Unfavorite shef' : 'Favorite shef'}</span>
    </div>
  );

  return (
    <div className='flex items-end justify-center py-4'>
      {renderFavoriteButton}
      {renderShareDishButton}
    </div>
  );
};
